import React, { useState } from "react";
import axios from "axios";
import { Button, Image } from "react-bootstrap";


export default function ButtonSingpassLogin() {

    const basePath = process.env.MIX_REACT_BASEPATH || "";


    const [loading, setLoading] = useState(false);
    const [error, setError] = useState("");


    const handleRetrieve = async () => {

        setLoading(true);
        setError("");

        try {
            const { data } = await axios.get(`${basePath}/singpass`, { params: {
                myInfoType: 'login'
            }});


            if (data?.status === "success" && data.authoriseUrl) {

                // set cookie
                document.cookie = `code_verifier=${data.codeVerifier}; path=/; max-age=${60 * 1};`;
                document.cookie = `nonce=${data.nonce}; path=/; max-age=${60 * 1};`;

                // redirect
                window.location.href = data.authoriseUrl;
            }
            else {
                setError("Unexpected response from server.");
            }
        }
        catch (err) {
            console.error(err);
            setError("Failed to connect to Singpass. Please try again.");
        }
        finally {
            setLoading(false);
        }
    };

    return (

        // <div className="button">
        //     <Button className="w-100" onClick={handleRetrieve} variant="danger" disabled={loading}>{loading ? "Redirecting to Singpass..." : "Log in with Singpass"}</Button>
        //     {error && <p className="mt-1 text-warning">{error}</p>}
        // </div>

        <div className="button">
            <Button className="w-100 d-flex justify-content-center align-items-center" style={{ gap: "6px", fontSize: "20px" }} onClick={handleRetrieve} variant="danger" disabled={loading}>
                {
                    loading ? 
                    "Redirecting..." : (
                        <>
                            <span className="text-white" style={{ fontSize: "20px", fontWeight: "900" }}>Log in with</span>
                            <Image src="../assets/image/singpass_logo_white.svg" alt="Singpass Logo" style={{ height: "19px", marginTop: "6px" }} />
                        </>
                    )
                }
            </Button>
            {error && <p className="mt-1 text-warning">{error}</p>}
        </div>

    );
}
